/* @minVersion 7.1.6 */
/* @onlyBabel7 */

// use readOnlyError instead of attemptSet

export default function _classPrivateMethodSet() {
  throw new TypeError("attempted to reassign private method");
}
